module.exports = __webpack_public_path__ + "img/user-data.5f73e502.svg";